import type { ReactNode } from 'react';
import {
  FILE_TREE,
  IDE_WINDOW_TITLE,
  LEFT_ACTIVITY_ICONS,
  MENU_STRIP_ITEMS,
  RIGHT_ACTIVITY_ICONS,
  type ActivityIconDef
} from './landingIdeChromeData';

function ActivityBar({ icons, side }: { icons: ActivityIconDef[]; side: 'left' | 'right' }) {
  return (
    <div className={`lp-ide-activity lp-ide-activity--${side}`} aria-hidden>
      {icons.map((icon) =>
        icon.id === 'spacer' ? (
          <div key="spacer" className="lp-ide-activity-spacer" />
        ) : (
          <div
            key={icon.id}
            className={`lp-ide-activity-icon${icon.active ? ' lp-ide-activity-icon--active' : ''}`}
          >
            {icon.label}
          </div>
        )
      )}
    </div>
  );
}

export function LandingIdeChrome({ children }: { children: ReactNode }) {
  return (
    <div className="lp-ide-chrome" aria-label="Penrose IDE preview">
      <div className="lp-ide-titlebar" aria-hidden>
        <div className="lp-ide-traffic">
          <span className="lp-ide-traffic-light" />
          <span className="lp-ide-traffic-light" />
          <span className="lp-ide-traffic-light" />
        </div>
        <span className="lp-ide-titlebar-title">{IDE_WINDOW_TITLE}</span>
        <span className="lp-ide-panel-toggle">Penrose</span>
      </div>

      <div className="lp-ide-menustrip" aria-hidden>
        <span className="lp-ide-menustrip-app">Penrose IDE</span>
        {MENU_STRIP_ITEMS.map((item) => (
          <span key={item} className="lp-ide-menustrip-item">
            {item}
          </span>
        ))}
      </div>

      <div className="lp-ide-main">
        <ActivityBar icons={LEFT_ACTIVITY_ICONS} side="left" />

        <aside className="lp-ide-sidebar">
          <h6 className="lp-ide-sidebar-title">Explorer</h6>
          <div className="lp-ide-file-tree">
            {FILE_TREE.map((row) => (
              <div
                key={row.label}
                className="lp-ide-file-tree-row"
                style={{
                  paddingInlineStart: `calc(var(--space-3) + ${row.depth} * var(--space-3))`
                }}
              >
                {row.label}
              </div>
            ))}
          </div>
        </aside>


        <div className="lp-ide-penrose">
          <div className="lp-ide-penrose-brand" aria-hidden>
            PENROSE
          </div>
          <div className="lp-ide-penrose-body">{children}</div>
        </div>

        <ActivityBar icons={RIGHT_ACTIVITY_ICONS} side="right" />
      </div>

      <footer className="lp-ide-statusbar">
        <span>main</span>
        <span>0 problems</span>
        <span className="lp-ide-statusbar-end">Signed into Penrose</span>
      </footer>
    </div>
  );
}
